// extracted by mini-css-extract-plugin
export default {"wrapper":"FileSharing_wrapper__z1znF","copy_button":"FileSharing_copy_button__LJ+Uc","expiration":"FileSharing_expiration__Nydci","notification":"FileSharing_notification__8Cszi"};